"use client";
import React, { useEffect, useState } from "react";
import { get_product_api, get_common_attributes_api } from "../Config/API";
import { NavLink, useParams, useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

import ToolSpecs from "../Components/ToolSpecs";
import SweetAlert from "sweetalert2";
import html2canvas from "html2canvas";
import AWS from "aws-sdk";
import { Buffer } from "buffer";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import SearchableSelect from "../Components/SerachableSelect";
import { useSelector, useDispatch } from "react-redux";
import { addToCart, createCart, updateCart } from "./../Redux/slices/cartSlice";
import {
  v_bottom_common_attributes,
  v_top_common_attributes,
} from "../Config/API/APIConstant";
window.Buffer = Buffer;
export default function Dashboard({ isSidebarOpen, toggle }) {
  const {
    register,
    handleSubmit,
    formState,
    getValues,
    setError,
    control,
    clearErrors,
  } = useForm({
    resolver: yupResolver(),
    mode: "onChange",
  }); // initialise the hook

  
  const user_details = JSON.parse(localStorage.getItem("user_details"));

  const { items:cartarr, totalQuantity } = useSelector(
    (state) => state.cart
  );

  // console.log("cartarr", cartarr);
  // console.log("totalQuantity", totalQuantity);
  const dispatch = useDispatch();

  const handle_onchange2 = (attributeName, value, option) => {
    console.log(`${attributeName} selected: ${value}`);
    console.log(`${attributeName} selected`, option);
    setAttributes_values((prevAttributes) => ({
      ...prevAttributes,
      [attributeName]: option,
    }));
  };

  const [product, setProduct] = useState({});
  const [attributes, setAttributes] = useState([]);
  const [common_attributes, setCommon_attributes] = useState({
    data: [],
    loading: false,
  });
  const [top_common_attributes, setTop_common_attributes] = useState(
    v_top_common_attributes
  );
  const [bottom_common_attributes, setBottom_common_attributes] = useState(
    v_bottom_common_attributes
  );
  const [attribute_values, setAttributes_values] = useState({});
  const location = useLocation();

  // console.log("location",location.state)
  const navigate = useNavigate();

  const { tool_subcategory } = useParams();

  useEffect(() => {
    if (tool_subcategory && tool_subcategory != "") {
      let payload = {
        uuid: tool_subcategory,
      };
      get_product_api(payload).then((res) => {
        console.log("res", res.data);
        setProduct(res.data.data);
        let arr =
          res?.data?.attributes.length > 0
            ? res?.data?.attributes.map((ele) => {
                let obj = { ...ele, attribute_value: "" };
                return obj;
              })
            : [];
        // console.log("arr",arr);
        setAttributes(arr);
      });

      fetch_attributes();
    }
  }, [tool_subcategory]);

  const handle_next = (items, obj) => {
    SweetAlert.fire({
      title:
        "Would you like to create a quotation or add the tool to your cart ? \n",
      // text: "Once deleted, you will not be able to recover this record !",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "rgb(38 171 131)",
      cancelButtonColor: "#807e7ed7",
      confirmButtonText: "Create Quotation",
      cancelButtonText: "Add Tool to Cart",
      reverseButtons: true,
    }).then(async (result) => {
      console.log("result", result);
      // console.log("items",items);
      //   console.log("obj",obj);
      if (result.isConfirmed) {
        console.log("clicked button OK");

        // let res=await  generateImageAndUpload()
        // generateImageAndUpload2(items,obj)
        generateImageAndUpload(items, obj);
      } else if (result.isDismissed && result.dismiss == "cancel") {
        console.log("clicked button cancel");

        // console.log("clicked button");
        // console.log("items",items);
        // console.log("obj",obj);

        generateImageAndUpload(items,obj,true)
      }
      //
    });
  };

  function fetch_attributes() {
    setCommon_attributes({ data: [], loading: true });

    get_common_attributes_api().then(
      (res) => {
        console.log("res", res.data);

        const result = res.data.data
          .filter((item1) => item1.visible_in_quote == true)
          .map((item1) => {
            const matchingItem = v_top_common_attributes.find(
              (item2) => item2.attribute_name === item1.attribute_name
            );
            if (matchingItem) {
              return {
                sequence: matchingItem.sequence,
                ...item1,
              };
            }
            return null;
          })
          .filter((item) => item !== null)
          .sort((a, b) => {
            if (a.sequence > b.sequence) {
              return 1;
            } else {
              return -1;
            }
          });

        console.log("resutl", result);
        const result2 = res.data.data
          .filter((item1) => item1.visible_in_quote == true)
          .map((item1) => {
            const matchingItem = v_bottom_common_attributes.find(
              (item2) => item2.attribute_name === item1.attribute_name
            );
            if (matchingItem) {
              return {
                sequence: matchingItem.sequence,
                ...item1,
              };
            }
            return null;
          })
          .filter((item) => item !== null)
          .sort((a, b) => {
            if (a.sequence > b.sequence) {
              return 1;
            } else {
              return -1;
            }
          });
        // console.log("resutl2",result2);
        // console.log("resutl",result);

        setBottom_common_attributes(result2);
        setTop_common_attributes(result);
        setCommon_attributes({
          loading: false,
          data: res.data.data,
        });
      },
      (err) => {
        setCommon_attributes({
          loading: false,
          data: [],
        });
      }
    );
  }

  // const handle_onchange = (attributeName, attributeValue) => {
  //   setAttributes_values((prevAttributes) => ({
  //     ...prevAttributes,
  //     [attributeName]: attributeValue,
  //   }));
  // };

  const uploadToS3 = (fileName, imageData) => {
    AWS.config.update({
      accessKeyId: process.env.REACT_APP_ACCESS_KEY_ID, // Replace with your access key
      secretAccessKey: process.env.REACT_APP_SECRET_ACCESS_KEY, // Replace with your secret key
      region: process.env.REACT_APP_REGION, // Replace with your S3 bucket region
    });

    const s3 = new AWS.S3();
    const params = {
      Bucket: process.env.REACT_APP_S3_BUCKET_NAME, // Replace with your S3 bucket name
      Key: fileName,
      Body: imageData,
      ContentType: "image/png",
      ACL: "public-read", // Optional: makes the file publicly accessible
    };

    return s3.upload(params).promise();
  };

  // Below code is working for downloading image with dimension
  const generateImageAndUpload = async (items, obj, isAddToCart = false) => {
    const input = document.getElementById("tool-container12");

    // 1. Download the background image first
    const downloadBackgroundImage = async (imageUrl) => {
      const response = await fetch(imageUrl, {
        method: "GET",
        mode: "cors", // Ensures CORS is handled
        cache: "no-cache", // Prevents caching issues
        headers: {
          "Content-Type": "application/octet-stream",
        },
      });

      // const response = await fetch(imageUrl);
      const blob = await response.blob();
      const imageObjectUrl = URL.createObjectURL(blob);
      return imageObjectUrl;
    };

    try {
      const backgroundUrl = product.product_image; // Your image URL

      // 2. Get the background image and set it as the div's background
      const downloadedImageUrl = await downloadBackgroundImage(backgroundUrl);

      // Set the background to the downloaded image
      input.style.backgroundImage = `url(${downloadedImageUrl})`;

      // 3. Convert the div to an image
      html2canvas(input, { useCORS: true }).then(async (canvas) => {
        const imgData = canvas.toDataURL("image/png");

        // Convert to binary for upload
        const base64Data = Buffer.from(
          imgData.replace(/^data:image\/\w+;base64,/, ""),
          "base64"
        );

        // Functionality to download the image directly
        const downloadImage = (dataUrl, fileName) => {
          const a = document.createElement("a");
          a.href = dataUrl;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        };

        const fileName = `Quotation/Image-${new Date().toISOString()}.png`;

        // Trigger download of the generated image
        // downloadImage(imgData, fileName);

        try {
          // Upload to S3
          const uploadResult = await uploadToS3(fileName, base64Data);

          console.log("Upload successful:", uploadResult);

          // Print the URL
          const imageUrl = uploadResult.Location;
          console.log("Image URL:", imageUrl);

          // console.log("Image URL:", imageUrl);

          if (isAddToCart) {
            const payload = {
              ...product,
              items: items,
              common_attributes: obj,
              quotation_product_img: imageUrl,
            };
            if(cartarr.length>0){
              dispatch(updateCart({ user_id: user_details.user_id ,items:[...cartarr,payload],quantity:totalQuantity+1}))

            }else{

              dispatch(createCart({ user_id: user_details.user_id ,items:[payload]}))
            }

            toast.success("Product added to the cart successfully !", {
                      autoClose: 2000,
                    });
            setTimeout(()=>{
              navigate("/my_products");

            },2002)
            
          } else {
            navigate(`/preview_quotation`, {
              state: {
                items: items,
                product: product,
                common_attributes: obj,
                quotation_product_img: imageUrl,
              },
            });
          }

          // return imageUrl;
          // setQuotation_img(imageUrl)
          // Use this URL as needed
          // alert(`Image uploaded successfully: ${imageUrl}`);
        } catch (error) {
          console.log("error", error);
          console.error("Error uploading to S3:", error);
          // return null;
        }
      });
    } catch (error) {
      console.error("Error downloading background image:", error);
    }
  };

  const generateImageAndUpload2 = async (items, obj) => {
    const input = document.getElementById("tool-container12");

    try {
      // 1. Convert the div to an image
      html2canvas(input, { useCORS: true }).then(async (canvas) => {
        // Get the image data as Base64
        const imgData = canvas.toDataURL("image/png");

        // Convert Base64 to binary for upload
        const base64Data = Buffer.from(
          imgData.replace(/^data:image\/\w+;base64,/, ""),
          "base64"
        );

        // Define the file name
        const fileName = `Quotation/Image-${new Date().toISOString()}.png`;

        try {
          // Upload to S3
          const uploadResult = await uploadToS3(fileName, base64Data);

          console.log("Upload successful:", uploadResult);

          // Print the URL
          const imageUrl = uploadResult.Location;
          console.log("Image URL:", imageUrl);

          navigate(`/preview_quotation`, {
            state: {
              items: items,
              product: product,
              common_attributes: obj,
              quotation_product_img: imageUrl,
            },
          });
        } catch (error) {
          console.error("Error uploading to S3:", error);
        }
      });
    } catch (error) {
      console.error("Error generating image:", error);
    }
  };

  const handleSpecInput=(attribute_uuid, value)=>{
    // console.log("attribute_uuid", attribute_uuid , "---", value); 
    
 let arr=  attributes.map(item => {
      if (item.uuid === attribute_uuid) {
        return { ...item, ["attribute_value"]: value }; 
      }
      return item; 
    });

    // console.log("arr----",arr)

   setAttributes(arr)

  }

  return (
    <div className="px-4 h-full">
            <ToastContainer />
      
      <div className="p-3 border-b border-gray-400 mb-6">
        <span
          className="mb-0 font-medium text-secondary-color cursor-pointer "
          onClick={() => {
            navigate(-2);
            // toggle()
          }}
        >
          {location.state.path_arr[0]}
        </span>{" "}
        <span>{"/"}</span>{" "}
        <span
          className="mb-0 font-medium text-secondary-color cursor-pointer"
          onClick={() => {
            navigate(-1);
          }}
        >
          {location.state.path_arr[1]}
        </span>{" "}
        <span>{"/"}</span>{" "}
        <span className="mb-0 font-medium text-main-color ">
          {location.state.path_arr[2]}
        </span>
      </div>
      <div className="flex justify-between mt-2 ">
        {/* Image Section */}
        <div
          className={
            isSidebarOpen == false ? `basis-[56%] pr-5` : `flex-2 pr-5`
          }
        >
          <h3 className="text-lg font-semibold">Standard</h3>
          <p className="text-gray-600">
            Solid carbide tooling designed for machining in a variety of
            applications and
          </p>

          <div
          // id="tool-container12"
          >
            <div
              className="tool-container"
              id="tool-container12"
              style={{
                background: `url(${product.product_image}) no-repeat center/contain`,
              }}
            >
              <ToolSpecs
                initialSpecs={attributes}
                setAttributes={setAttributes}
              />
            </div>
          </div>
          
        </div>

        {/* Form Section */}
        <div
          className={
            isSidebarOpen == false
              ? `basis-[42%] pl-2 h-dvh overflow-auto pb-[18%] `
              : `flex-2 pl-2 h-dvh overflow-y-auto pb-[18%] `
          }
        >
          {/* Tool Material Section */}
          <div className="mb-8">
            <h3 className="text-lg font-semibold">Tool Material</h3>
            <div className="flex flex-wrap gap-4">
              <div className="flex-32">
                <label className="block mb-2">Tool Number</label>
                <div className="relative w-full">
                  <input
                    type="text"
                    value={product.product_code}
                    readOnly
                    // className="w-full p-2 border border-gray-300 rounded bg-gray-100"
                    className="rounded-md inputBox1 w-full p-2"
                  />
                </div>
              </div>
              {top_common_attributes.map((item, ind) => {
                return (
                  <>
                    {item.attribute_type == "LOV" && item.visible_in_quote && (
                      <div className="flex-32">
                        <label className="block mb-2">
                          {item.attribute_name}
                        </label>
                       
                        <SearchableSelect
                          item={{
                            attribute_name: item.attribute_name,
                            attribute_value: item.attribute_value,
                          }}
                          handle_onchange={handle_onchange2}
                          placeholder={`Please select ${item.attribute_name.toLowerCase()}`}
                        />
                      </div>
                    )}

                    
                  </>
                );
              })}
              
            </div>
           
          </div>

          {/* Tool Dimension Section */}
          <div className="mb-8">
            <h3 className="text-lg font-semibold">Tool Parameters</h3>
            {attributes.map((attr, i) => (
              <div className="flex flex-wrap gap-4" key={i}>
                <div className="basis-[50%]">
                  <label className="block mb-2">
                    {attr.toolparameter.parameters_code}
                  </label>
                  <input
                    type="number"
                    value={attr.attribute_value}
                    className="w-full p-2 border border-gray-300 rounded"
                    onChange={(e)=>{
                      handleSpecInput(attr.uuid,e.target.value)
                    }}  
                    disabled={(attr.x_position=="" && attr.y_position=="")?false:true}
                  />
                </div>
                <div className="basis-[10%]">
                  {i == 0 && <label className="block mb-2">UOM</label>}
                  <input
                    type="text"
                    value={attr.uom_value}
                    className={
                      i == 0
                        ? `w-full p-2 border border-gray-300 rounded`
                        : "w-full p-2 mt-8 border border-gray-300 rounded"
                    }
                  />
                </div>
                <div className="basis-[15%]">
                  {i == 0 && <label className="block mb-2">+ TOL</label>}
                  <input
                    type="text"
                    value={attr.tol_positive}
                    className={
                      i == 0
                        ? `w-full p-2 border border-gray-300 rounded`
                        : "w-full p-2 mt-8 border border-gray-300 rounded"
                    }
                  />
                </div>
                <div className="basis-[15%]">
                  {i == 0 && <label className="block mb-2">- TOL</label>}
                  <input
                    type="text"
                    value={attr.tol_negative}
                    className={
                      i == 0
                        ? `w-full p-2 border border-gray-300 rounded`
                        : "w-full p-2 mt-8 border border-gray-300 rounded"
                    }
                  />
                </div>
              </div>
            ))}
          </div>

          {/* Common Attributes Section */}
          <div>
            <h3 className="text-lg font-semibold">Common Attributes</h3>
            <div className="flex flex-wrap gap-4">
              {bottom_common_attributes.map((item, ind) => {
                return (
                  <>
                    {item.attribute_type == "LOV" && item.visible_in_quote && (
                      <div className="flex-32">
                        <label className="block mb-2">
                          {item.attribute_name}
                        </label>
                        {/* <select
                          className={`rounded-md inputBox1`}
                          onChange={(e) => {
                            // console.log('selected');
                            // console.log('selected',e.target.value);
                            handle_onchange(
                              item.attribute_name,
                              e.target.value
                            );
                          }}
                        >
                          <option>{`Please select`}</option>
                          {item.attribute_value.map((attribute_value) => {
                            return <option>{attribute_value}</option>;
                          })}
                        </select> */}
                        <SearchableSelect
                          item={{
                            attribute_name: item.attribute_name,
                            attribute_value: item.attribute_value,
                          }}
                          handle_onchange={handle_onchange2}
                          placeholder={`Please select ${item.attribute_name.toLowerCase()}`}
                        />
                      </div>
                    )}

                    {item.attribute_name == "Workpiece Material" &&
                      item.visible_in_quote && (
                        <div className="flex-32">
                          <label className="block mb-2">ISO Class</label>
                          <div className="relative w-full">
                            <input
                              type="text"
                              value={
                                attribute_values["Workpiece Material"]
                                  ?.iso_classification
                                  ? attribute_values["Workpiece Material"]
                                      ?.iso_classification
                                  : "NA"
                              }
                              readOnly
                              className="rounded-md inputBox1 w-full p-2"
                            />
                          </div>
                        </div>
                      )}
                    

                   
                  </>
                );
              })}
            </div>
            <div className="flex mt-2 ">
              {bottom_common_attributes.map((item,ind)=>{
               return (<>
                {item.attribute_type == "string" &&
                      item.visible_in_quote && (
                        <div className="flex-1">
                          <label className="block mb-2">
                            {item.attribute_name}
                          </label>
                          <div className="relative w-full">
                            <textarea
                              className="resize-x rounded-md w-full p-2 greyBorder"
                              placeholder={
                                item.attribute_value
                                  ? `${item.attribute_value}`
                                  : `Enter ${item.attribute_name}`
                              }
                              onChange={(e) => {
                                //  console.log("e.target.value",e.target.value);
                                setAttributes_values((prevAttributes) => ({
                                  ...prevAttributes,
                                  [item.attribute_name]: {
                                    name: e.target.value,
                                    value: e.target.value,
                                  },
                                }));
                              }}
                            ></textarea>
                           
                          </div>
                        </div>
                      )}
                </>)
              })}
            </div>
           
          </div>
          <div className="mt-4">
            <button
              className=" main-color  p-3 rounded-lg text-white mt-2 cursor-pointer"
              onClick={() => {
                console.log("values", attributes);
                console.log("attributes values", attribute_values);

                handle_next(attributes, attribute_values);
              }}
            >
              Next <i class="fa fa-arrow-right" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
